/**
 * MetaTrader server name presets (FxPro-style + autres brokers courants).
 * MT4 vs MT5 : les noms FxPro.com-* sont typiquement MT4 ; FxPro-MT5* sont MT5.
 */

/** FxPro MT4 — liste officielle app mobile MetaTrader (photos FxPro). */
export const FXPRO_MT4_SERVERS = [
  "FxPro.com-Demo01",
  "FxPro.com-Demo05",
  "FxPro.com-Demo06",
  ...Array.from({ length: 9 }, (_, i) => `FxPro.com-Real${String(i + 1).padStart(2, "0")}`),
];

/** FxPro MT5 — liste officielle app mobile FxPro (4 serveurs). */
export const FXPRO_MT5_SERVERS = [
  "FxPro-MT5",
  "FxPro-MT5 Demo",
  "FxPro-MT5 Live02",
  "FxPro-MT5 Live03",
];

const MT4_GENERIC = [
  "ICMarketsSC-Demo",
  "ICMarketsSC-Live",
  "ICMarketsSC-Live06",
  "Pepperstone-Demo",
  "Pepperstone-Live",
  "XMGlobal-Real",
  "XMGlobal-Demo",
  "VantageInternational-Live",
  "VantageInternational-Demo",
];

const MT5_GENERIC = [...MT4_GENERIC];

/** @deprecated Utiliser presetsForPlatform ; conservé pour compat imports existants. */
export const MT_KNOWN_SERVERS = [
  ...new Set([...FXPRO_MT4_SERVERS, ...FXPRO_MT5_SERVERS, ...MT4_GENERIC]),
];

export function presetsForPlatform(platform) {
  const p = String(platform || "").toUpperCase();
  const set = new Set();
  if (p === "MT4") {
    FXPRO_MT4_SERVERS.forEach((s) => set.add(s));
    MT4_GENERIC.forEach((s) => set.add(s));
  } else if (p === "MT5") {
    FXPRO_MT5_SERVERS.forEach((s) => set.add(s));
    MT5_GENERIC.forEach((s) => set.add(s));
  } else {
    MT_KNOWN_SERVERS.forEach((s) => set.add(s));
  }
  return [...set].filter(Boolean);
}

/** Path 1 Broker partner — tous les serveurs FxPro (démos + réels) par plateforme. */
export const PATH1_PARTNER_MT4_SERVERS = [...FXPRO_MT4_SERVERS];
export const PATH1_PARTNER_MT5_SERVERS = [...FXPRO_MT5_SERVERS];

/** Liste FxPro Path 1 — séparée par plateforme (jamais MT4 + MT5 mélangés). */
export function fxproPresetsForPlatform(platform) {
  const p = String(platform || "").toUpperCase();
  if (p === "MT4") return [...PATH1_PARTNER_MT4_SERVERS];
  if (p === "MT5") return [...PATH1_PARTNER_MT5_SERVERS];
  return [];
}

const FXPRO_MT4_EXACT = new Set(
  FXPRO_MT4_SERVERS.map((s) => s.toLowerCase()),
);
const FXPRO_MT5_EXACT = new Set(
  FXPRO_MT5_SERVERS.map((s) => s.toLowerCase()),
);

export function isFxProServerName(name, platform) {
  const n = String(name || "").trim();
  if (!n) return false;
  const p = String(platform || "").toUpperCase();
  if (p === "MT4") return FXPRO_MT4_EXACT.has(n.toLowerCase());
  if (p === "MT5") return FXPRO_MT5_EXACT.has(n.toLowerCase());
  return (
    FXPRO_MT4_EXACT.has(n.toLowerCase()) ||
    FXPRO_MT5_EXACT.has(n.toLowerCase())
  );
}
